import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FeatureCardsManager } from "@/components/admin/website/FeatureCardsManager";
import { PagesManager } from "@/components/admin/website/PagesManager";
import { SiteSettingsForm } from "@/components/admin/website/SiteSettingsForm";
import { EnquiriesManager } from "@/components/admin/website/EnquiriesManager";
import { BookingSettings } from "@/components/admin/website/BookingSettings";
import { RedirectsManager, ImportPanel } from "@/components/admin/website/RedirectsImport";

const TABS = [
  ["pages", "Pages", PagesManager], ["features", "Feature Cards", FeatureCardsManager], ["enquiries", "Enquiries & Trials", EnquiriesManager], ["booking", "Booking & Calendar", BookingSettings],
  ["site", "Menu, Footer & Brand", SiteSettingsForm], ["redirects", "Redirects", RedirectsManager], ["import", "Import", ImportPanel],
];

export const WebsiteTab = () => (
  <Tabs defaultValue={new URLSearchParams(window.location.search).get("gcal") ? "booking" : "pages"} className="w-full" data-testid="website-tab">
    <TabsList className="flex flex-wrap h-auto gap-1 mb-4 bg-slate-100">
      {TABS.map(([v, label]) => <TabsTrigger key={v} value={v} data-testid={`website-subtab-${v}`}>{label}</TabsTrigger>)}
    </TabsList>
    {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
  </Tabs>
);
